import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

import { StyledDialog } from 'theme/index';

interface DocumentPreviewDialogProps {
  open: boolean;
  pdfUrl?: string;
  documentName?: string;
  loading?: boolean;
  onClose: () => void;
}

const DocumentPreviewDialog: React.FC<DocumentPreviewDialogProps> = ({
  open,
  pdfUrl,
  documentName,
  loading = false,
  onClose,
}) => {
  let dialogContent: React.ReactNode;

  if (loading) {
    dialogContent = (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  } else if (pdfUrl) {
    dialogContent = (
      <Box
        component="iframe"
        src={pdfUrl}
        title={documentName ?? 'Document PDF preview'}
        sx={{
          width: '100%',
          height: { xs: 360, sm: 520 },
          border: '1px solid #F2F4F7',
          borderRadius: 1,
        }}
      />
    );
  } else {
    dialogContent = (
      <Typography color="text.secondary">
        No PDF available for this document.
      </Typography>
    );
  }

  return (
    <StyledDialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>
        Document Preview
        {documentName ? ` — ${documentName}` : ''}
      </DialogTitle>

      <DialogContent>{dialogContent}</DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        {pdfUrl && !loading && (
          <Button
            variant="outlined"
            component="a"
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open in New Tab
          </Button>
        )}

        <Button variant="contained" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default DocumentPreviewDialog;
